export default __webpack_public_path__ + "static/media/loginBackground0.d25888f9.jpg";